module.exports = __webpack_public_path__ + "img/no-data-training.6e15dd29.svg";